import { FC } from 'react';

import { Wrapper } from './styled';

type TProps = {};

export const Footer: FC<TProps> = () => {
  return <Wrapper>©2026 Общество с ограниченной ответственностью «АПЛОСОФТ»</Wrapper>;
};
